<md-content-box [type]="type()">
	<ng-content></ng-content>
</md-content-box>
